export function getSafeToken() {
  try {
    const raw = localStorage.getItem('token');
    if (!raw) return null;
    if (raw === 'null' || raw === 'undefined') return null;
    return raw;
  } catch (err) {
    return null;
  }
}
